import { Component, OnInit } from '@angular/core';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import { SccMainDicomTags } from 'src/app/shared/models/scc-main-dicom-tags';

@Component({
  selector: 'app-scc-dicom-data',
  templateUrl: './scc-dicom-data.component.html',
  styleUrls: ['./scc-dicom-data.component.scss']
})
export class SccDicomDataComponent implements OnInit, IDialogContentComponent<void, { dicomData: SccMainDicomTags }> {
  input?: { dicomData: SccMainDicomTags };

  ngOnInit(): void {}

  getResult(): void {}

  isDisabled(): boolean {
    return false;
  }

  /**
   * Returns true if the value is a simple string or an array of strings.
   */
  public isSimpleValue(value: any): boolean {
    if (typeof value === 'string') {
      return true;
    }

    if (Array.isArray(value) && value.every(item => typeof item === 'string')) {
      return true;
    }

    return false;
  }

  /**
   * Returns true if the value is an array.
   */
  public isArray(value: any): boolean {
    return Array.isArray(value);
  }

  /**
   * Returns true if the value is a non-null object (and not an array).
   */
  public isObject(value: any): boolean {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  /**
   * Helper method to convert an object into an array of key/value pairs.
   */
  public objectEntries(obj: any): { key: string; value: any }[] {
    return Object.entries(obj).map(([key, value]) => ({ key, value }));
  }
}
